import { render, staticRenderFns } from "./icn-infos.vue?vue&type=template&id=7224977e&scoped=true&"
import script from "./icn-infos.vue?vue&type=script&lang=js&"
export * from "./icn-infos.vue?vue&type=script&lang=js&"
import style0 from "./icn-infos.vue?vue&type=style&index=0&id=7224977e&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224977e",
  null
  
)

export default component.exports